/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemIdentifierAccessCodeModel } from '../../models/system-identifier-access-code-model';

export interface AdminSystemIdentifierAccessCodeGetIdGet$Params {

/**
 * The unique identifier of the access code
 */
  id: string;
}

export function adminSystemIdentifierAccessCodeGetIdGet(http: HttpClient, rootUrl: string, params: AdminSystemIdentifierAccessCodeGetIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<SystemIdentifierAccessCodeModel>> {
  const rb = new RequestBuilder(rootUrl, adminSystemIdentifierAccessCodeGetIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<SystemIdentifierAccessCodeModel>;
    })
  );
}

adminSystemIdentifierAccessCodeGetIdGet.PATH = '/Admin/SystemIdentifierAccessCodeGet/{id}';
